import axios from "axios";

// Base URL for backend API (update this if needed)
const API_BASE_URL = "http://localhost:8080/api"; // Adjust if your backend runs on a different port

// Create an Axios instance for consistent API requests
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Example: Fetch employees from backend
export const fetchEmployees = async () => {
    try {
        const response = await api.get("/users");
        return response.data;
    } catch (error) {
        console.error("Error fetching employees:", error);
        return [];
    }
};

// Example: Fetch reports from backend
export const fetchReports = async () => {
    try {
        const response = await api.get("/reports");
        return response.data;
    } catch (error) {
        console.error("Error fetching reports:", error);
        return [];
    }
};

export default api;
